import { createStyles, LinearProgress, Theme, Typography } from "@material-ui/core";
import { withStyles } from "@material-ui/styles";
import React, { Component } from "react";
import { connect, ConnectedProps } from "react-redux";
import { RouteComponentProps } from "react-router";
import { ApplicationState } from "../..";
import { endpoints } from "../../api/rtk/LocationApi";
import { NewEntityId } from "../../data/constants";
import { LocationViewModel } from "../../model/LocationViewModel";
import { routesPaths } from "../../Routes";
import { navigateTo } from "../../utils/Navigation";
import TranslatedMessage from "../translations/TranslatedMessage";
import LocationGrid from "./LocationGrid";

const styles = ({ spacing }: Theme) =>
  createStyles({
    button: { margin: spacing(1) },
    icon: { marginRight: spacing(1) },
  });

const mapStateToProps = (state: ApplicationState) => {
  return {
    locationsState: endpoints.getLocations.select()(state),
  };
};
const mapDispatchToProps = {
  getLocations: endpoints.getLocations.initiate,
};
const connector = connect(mapStateToProps, mapDispatchToProps);

type LocationListProps = ConnectedProps<typeof connector> & RouteComponentProps;

type LocationListState = {
  locations: LocationViewModel[];
};

class LocationList extends Component<LocationListProps, LocationListState> {
  constructor(props: any) {
    super(props);
    this.state = {
      locations: [],
    };
  }

  public componentDidMount() {
    this.props.getLocations();
  }

  public render() {
    return (
      <>
        <Typography variant="h5">
          <TranslatedMessage id="location.header" />
        </Typography>
        {this.renderLocations()}
      </>
    );
  }
  private renderLocations(): JSX.Element {
    const { isLoading, data: locations } = this.props.locationsState;

    if (isLoading) {
      return <LinearProgress variant="query" />;
    }

    if (locations === undefined) {
      return <></>;
    }

    return (
      <LocationGrid
        locations={locations}
        onLocationClick={this.navigateToLocation}
        onAddClick={() => this.navigateToLocation(NewEntityId)}
      />
    );
  }

  private navigateToLocation = (locationId: string) => {
    navigateTo(routesPaths.location(locationId), this.props.history);
  };
}

export default withStyles(styles)(connector(LocationList));
